// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RefObject, useEffect, useState } from "react";

interface Size {
    bottom?: number;
    height?: number;
    left?: number;
    right?: number;
    top?: number;
    width?: number;
    x?: number;
    y?: number;
}

export default function useSize(ref: RefObject<any>): Size | undefined {
    const [size, setSize] = useState<Size>({});

    useEffect(() => {
        if (ref.current == null) {
            return;
        }

        const observer = new (window as any).ResizeObserver(([entry]: any) => setSize(entry.contentRect));
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return size;
}

export function useElementSize(element: HTMLElement): Size | undefined {
    const [size, setSize] = useState<Size>({});

    useEffect(() => {
        if (!element) {
            return;
        }

        const observer = new (window as any).ResizeObserver(([entry]: any) => setSize(entry.contentRect));
        observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return size;
}
